<!-- Since issue 53  -->
<div class="card-header" id="extractionInstallMESHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#extractionInstallMESCollapse" aria-expanded="true" aria-controls="extractionInstallMESCollapse">
        Rechercher une liste d'installations mises en service
    </button>
</div>

<div id="extractionInstallMESCollapse" class="panel-collapse collapse" aria-labelledby="extractionInstallMESHeader"
    data-parent="#accordionExtraction">

    <div class="card-body row">
        <form [formGroup]="searchInstallMesForm" (ngSubmit)="onSubmitMesInstall()" class="wrapper shadowed">
            <h4>Rechercher une liste d'installations mises en service</h4>
            <br>
            <div class="paragraphe">
                <mat-form-field>
                    <input matInput [matDatepicker]="mesDate" placeholder="Mise en service après"
                        formControlName="mesDate">
                    <mat-datepicker-toggle matSuffix [for]="mesDate"></mat-datepicker-toggle>
                    <mat-datepicker #mesDate startView="month"></mat-datepicker>
                </mat-form-field>

            </div>


            <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>

        </form>
        <br><br>

        <app-gmao-spinner *ngIf="isLoading"></app-gmao-spinner>


        <ng-container *ngIf="installMes">
            <div class="wrapper shadowed">

                <br />

                <h4>Résultats</h4>

                <app-export-button [data]="installMes"></app-export-button>

                <br />

                <ng-container *ngIf="installMes">
                    <p>Total pour la période sélectionée : <span class="count-total">{{installMes.length}}</span>
                    </p>
                </ng-container>

                <mat-table [dataSource]="installMes">
                    <ng-container matColumnDef="numSerie">
                        <mat-header-cell *matHeaderCellDef> Numéro de série </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{install.NUMERO_SERIE}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dateMes">
                        <mat-header-cell *matHeaderCellDef> Date de mise en service </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{getNiceDate(install.DATE_MISE_EN_SERVICE)}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nom">
                        <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
                        <mat-cell *matCellDef="let install"> {{install.NOM_INSTALLATION}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumnInstallMes"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: ['numSerie', 'dateMes', 'nom'] ;" (click)="clickInstall(row)">
                    </mat-row>
                </mat-table>

            </div>
        </ng-container>
        <br />
    </div>
</div>